export const MEMORY_CAPACITY_PARAM_SLUG = 'obem-vstroennoi-pamiati';